export const BASE_URL_API_TRANXT_UAT_API = `https://api.shubhpaisa.com/api/ShubhPaisa`;